export const costs = [
  'Sleepless nights searching for ways to translate complex hydrological processes into language your students can understand.',
  "Improvised classes because you couldn't find clear, ready-to-use materials in time.",
  "Disconnected students who don't see how hydrology connects to water security, climate, or their communities.",
  "Awkward silences when a student asks how aquifers work or why droughts happen and you don't have a clear answer.",
  'Weekends lost building lesson plans, watershed projects, and assessments from scratch over and over.',
  'Uncertainty about how to teach groundwater systems, flood hazards, or water quality without adequate resources.',
];
